export const flagClass = (flag) => {
  switch (flag) {
    case "green":
      return "bg-emerald-50 text-emerald-800 border-emerald-200";
    case "amber":
      return "bg-yellow-50 text-yellow-900 border-yellow-200";
    case "orange":
      return "bg-orange-50 text-orange-900 border-orange-200";
    case "red":
      return "bg-rose-50 text-rose-900 border-rose-200";
    case "neutral":
      // "New Item" / "No Benchmark" — AI could not compare against prior data.
      // Amber tone signals "human judgement required" without implying risk
      // (red) or safety (green).
      return "bg-amber-50 text-amber-900 border-amber-300";
    default:
      return "bg-slate-50 text-slate-700 border-slate-200";
  }
};

export const actionClass = (action) => {
  if (action === "APPROVE") return "bg-emerald-50 text-emerald-800 border-emerald-200";
  if (action === "REVIEW") return "bg-yellow-50 text-yellow-900 border-yellow-200";
  if (action === "HOLD") return "bg-rose-50 text-rose-900 border-rose-200";
  return "bg-slate-50 text-slate-700 border-slate-200";
};

// When the backend returns flag='neutral', the item/PR has no prior data for
// comparison. Surface that explicitly instead of falling back to "No history"
// (which read as neutral-ish but sat on a green pill).
export const priceLabel = (pf) => {
  if (!pf) return "—";
  if (pf.flag === "neutral") return "New Item";
  if (pf.change_pct === null || pf.change_pct === undefined) return "New Item";
  const v = pf.change_pct;
  if (v === 0) return "Same";
  if (v < 0) return `${v.toFixed(1)}%`;
  return `+${v.toFixed(1)}%`;
};

export const vendorLabel = (vf) => {
  if (!vf) return "—";
  if (vf.flag === "neutral") return "No Benchmark";
  // Legacy label — kept for pre-neutral responses still cached in the mirror.
  if (vf.label === "No Alt Vendor") return "No Benchmark";
  if (vf.label === "Best Cost") return "Best";
  // For same-vendor price hikes, append the DATE of the cheapest bill so
  // requester/approver can judge staleness at a glance:
  //   • ≤90 days ago → likely recent hike, worth negotiating back down
  //   • >6 months    → probably stable "new normal", safe to ignore
  if (vf.same_vendor && vf.same_vendor_cheapest_vdate) {
    return `${vf.label} on ${fmtDate(vf.same_vendor_cheapest_vdate)}`;
  }
  return vf.label;
};

export const fmtAmt = (n) => {
  if (n === null || n === undefined) return "—";
  return Number(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
};


/** Age-based freshness indicator for a vdate (ISO string).
 * ≤30 days  → fresh (emerald)
 * ≤180 days → ageing (amber)
 * >180 days → stale  (slate)
 * Returns { days, tier, dotClass, textClass, tooltip } */
export const freshness = (s) => {
  if (!s) return null;
  const d = new Date(s);
  if (isNaN(d.getTime())) return null;
  const days = Math.max(0, Math.floor((Date.now() - d.getTime()) / 86_400_000));
  let tier, dotClass, textClass;
  if (days <= 30)       { tier = "fresh";  dotClass = "bg-emerald-500"; textClass = "text-emerald-700"; }
  else if (days <= 180) { tier = "ageing"; dotClass = "bg-amber-500";   textClass = "text-amber-800"; }
  else                  { tier = "stale";  dotClass = "bg-slate-400";   textClass = "text-slate-500"; }
  const ago = days === 0 ? "today" : days === 1 ? "1 day ago" : days < 31 ? `${days} days ago` : days < 365 ? `${Math.round(days / 30)} months ago` : `${(days / 365).toFixed(1)} years ago`;
  return { days, tier, dotClass, textClass, ago };
};
